import {SubscriptionPlan} from './subscription-plan.enum';

export class SubscriptionPlanChangeDto {
  subscription_plan: SubscriptionPlan;

  constructor(subscription_plan: SubscriptionPlan) {
    this.subscription_plan = subscription_plan;
  }
}
